import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue-600 w-12 h-12 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-2xl">PS</span>
              </div>
              <div>
                <div className="font-bold text-xl">Pusat Service</div>
                <div className="text-gray-400 text-sm">Water Heater</div>
              </div>
            </div>
            <p className="text-gray-400 leading-relaxed mb-4">
              Spesialis service dan perbaikan water heater dengan teknisi bersertifikat dan berpengalaman lebih dari 10 tahun. Melayani area Jabodetabek 24/7.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-4">Menu</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => document.getElementById('layanan')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-blue-500 transition-colors"
                >
                  Layanan
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('proses')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-blue-500 transition-colors"
                >
                  Proses
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('testimoni')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-blue-500 transition-colors"
                >
                  Testimoni
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('faq')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-blue-500 transition-colors"
                >
                  FAQ
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-bold text-lg mb-4">Kontak</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
                <div>
                  <div className="text-gray-400 text-sm">WhatsApp</div>
                  <a href="https://wa.me/6285776282868" className="hover:text-blue-500 transition-colors">
                    +62 857-7628-2868
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
                <div>
                  <div className="text-gray-400 text-sm">Area Layanan</div>
                  <div>Jabodetabek</div>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
                <div>
                  <div className="text-gray-400 text-sm">Jam Operasional</div>
                  <div>24 Jam / 7 Hari</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} Pusat Service Water Heater. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;